<div class="pageheader">
  <div class="page-title">
    <h1>Scheduler Task Details</h1>
    <div class="btn-group">
      <button type="button" class="btn btn-link" [disabled]="!InViewMode" (click)="refresh()">
        Refresh <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
      <app-change-log-link *bizPermissionRequired="'Scheduler_Action_Scheduling_ShowLog'" [disabled]="!InViewMode"
        [title]="'Logs for ' + $safeNavigationMigration(selectedSchedulerTask?.SchedulerTask?.Name)">
        <app-change-log-link-entity type="SchedulerTask" [id]="$safeNavigationMigration(selectedSchedulerTask?.SchedulerTask?.Id)">
        </app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<form [formGroup]="formModel" (ngSubmit)="onSave($event)" novalidate>
  <dx-validation-group #vg>
    <!-- Top Toolbar -->
    <div class="row mb-2">
      <div class="col-sm-12">
        <div class="btn-toolbar">
          @if (!InNewMode) {
            <div class="btn-group">
              <button type="button" class="btn btn-primary btn-sm" [disabled]="!InViewMode"
                *bizPermissionRequired="'Scheduler_Action_Scheduling_Edit'"
              (click)="onEdit($event)">Edit</button>
            </div>
            <div class="btn-group">
              <button type="button" class="btn btn-primary btn-sm" [disabled]="!InViewMode"
                *bizPermissionRequired="'Scheduler_Action_Scheduling_Delete'"
              (click)="onDelete($event)">Delete</button>
            </div>
            <div class="btn-group">
              <button type="button" class="btn btn-primary btn-sm" [disabled]="!InViewMode"
                (click)="navigateToLog($safeNavigationMigration(selectedSchedulerTask?.SchedulerTask?.Id))">
                Show scheduler task log
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Enabled -->
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <div class="control control-checkbox">
            <label>
              Enabled
              <input formControlName="enabled" type="checkbox" />
              <i></i>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Name / Type / Interval -->
    <div class="row">
      <div class="col-sm-7 col-lg-7">
        <div class="form-group">
          <label class="form-required">Name</label>
          <input formControlName="name" type="text" class="form-control" [bizFocus]="true"
            [class.invalid-state-border]="fcName.invalid" required />
            <div class="error" [class.invisible]="!fcName.invalid || (!fcName.dirty && !fcName.touched)">
              @if (fcName.errors?.nameExists) {
                <p>Name is already used</p>
              }
              @if (fcName.errors?.required) {
                <p>Name is required</p>
              }
            </div>
          </div>
        </div>
        <div class="col-sm-5 col-lg-2">
          <div class="form-group">
            <label class="form-required">Scheduler task handler</label>
            <select class="form-control" formControlName="schedulerTaskHandlerId"
              [class.invalid-state-border]="fcSchedulerTaskHandler.invalid" required>
              <option [ngValue]="null">Please choose...</option>
              @for (schedulerTaskHandler of schedulerTaskHandlers; track schedulerTaskHandler) {
                <option
                  [ngValue]="schedulerTaskHandler.Id">
                  {{ schedulerTaskHandler.Name }}
                </option>
              }
            </select>
            <div class="error"
              [class.invisible]="!fcSchedulerTaskHandler.invalid || (!fcSchedulerTaskHandler.dirty && !fcSchedulerTaskHandler.touched)">
              <div>Scheduler task handler is required</div>
            </div>
          </div>
        </div>
        @if (isFrequency) {
          <div class="col-sm-5 col-lg-3">
            <div class="form-group">
              <label class="form-required">Polling interval</label>
              <ep-duration-picker innerClass="form-control" formControlName="frequency"
              [invalid]="fcFrequency.invalid"></ep-duration-picker>
              <div class="error"
                [class.invisible]="!fcFrequency.invalid || (!fcFrequency.dirty && !fcFrequency.touched)">
                @if (fcFrequency.errors?.required) {
                  <div>Frequency is required</div>
                }
                @if (fcFrequency.errors?.min) {
                  <div>Minimum value is 30 seconds</div>
                }
                @if (!fcFrequency.errors?.required && !fcFrequency.errors?.min) {
                  <div>Error</div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <div class="row">
        <div class="col-sm-7 col-lg-7">
          <div class="form-group">
            <label class="form-required">Description</label>
            <input formControlName="description" type="text" class="form-control" [bizFocus]="true" />
          </div>
        </div>
      </div>

      <!-- Schedule -->
      <div class="row">
        <div class="col-lg-2">
          <div class="form-group">
            <div class="control control-checkbox">
              <label>
                Use max run time
                <input formControlName="useMaxRunTime" type="checkbox"
                  [formControl]="formModel.controls.useMaxRunTime" />
                  <i></i>
                </label>
              </div>
            </div>
          </div>
          @if (UseMaxRunTime) {
            <div class="col-lg-3">
              <div class="form-group">
                <div class="control">
                  <label>
                    Max minutes to run
                    <input [formControl]="formModel.controls.executionTimeInMinutes" type="number"
                      [invalid]="fcExecutionTimeInMinutes.invalid" />
                      <!-- <div class="error" [class.invisible]="!fcExecutionTimeInMinutes.invalid || (!fcExecutionTimeInMinutes.dirty && !fcExecutionTimeInMinutes.touched)"> -->
                      <div class="error" [class.invisible]="!fcExecutionTimeInMinutes.invalid">
                        @if (fcExecutionTimeInMinutes.errors?.required) {
                          <div>Minutes is required</div>
                        }
                        @if (fcExecutionTimeInMinutes.errors?.min) {
                          <div>Minimum value is 1 minute</div>
                        }
                        @if (!fcExecutionTimeInMinutes.errors?.required && !fcExecutionTimeInMinutes.errors?.min) {
                          <div
                            >
                          Error</div>
                        }
                      </div>
                      <i></i>
                    </label>
                  </div>
                </div>
              </div>
            }
          </div>

          @if (isFrequency) {
            <div class="row">
              <div class="col-sm-12">
                <ep-schedule-item [scheduleItem]="$safeNavigationMigration(selectedSchedulerTask?.ScheduledItem)" [readonly]="InViewMode"
                  [validateTriggerTimes]="true" [requireWeekdaySelection]="true">
                </ep-schedule-item>
                @if (selectedScheduler?.ScheduledItem.Triggers?.length === 0) {
                  <div>
                    Frequency schedule will be active 24/7/365. To restrict this, add a trigger above.
                  </div>
                }
              </div>
            </div>
          }

          @if (isFixed) {
            <div class="row">
              <div class="col-sm-12">
                <ep-schedule-item [scheduleItem]="$safeNavigationMigration(selectedSchedulerTask?.ScheduledItem)" [hideTriggerEnd]="true"
                  [requireAtLeastOneTrigger]="selectedSchedulerTask?.ScheduledItem.Triggers?.length === 0"
                  [readonly]="InViewMode" [validateTriggerTimes]="true" [requireWeekdaySelection]="true">
                </ep-schedule-item>
              </div>
            </div>
          }

          <!-- DataField Groups -->
          <div class="row mb-2">
            <div class="col-sm-12">
              <ep-datafield-group-container #dfgc [formValidationGroup]="dataFieldsFormGroup" [showError]="true"
                [datafieldGroups]="dataFieldGroups" [isAlwaysEditable]="!InViewMode" [numberOfColumns]="2">
              </ep-datafield-group-container>
            </div>
          </div>

          <!-- Bottom Toolbar -->
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="modal-footer btn-toolbar">
                @if (InViewMode) {
                  <div class="btn-group">
                    <button type="button" class="btn btn-primary btn-sm"
                      *bizPermissionRequired="'Scheduler_Action_Scheduling_Edit'" [disabled]=""
                      (click)="onEdit($event)">
                      Edit
                    </button>
                  </div>
                }
                @if (InEditMode || InNewMode) {
                  <div class="btn-group">
                    <button type="submit" class="btn btn-primary btn-sm">Save</button>
                  </div>
                  <div class="btn-group">
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCancel($event)">
                      Cancel
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </dx-validation-group>
      </form>
